import React, { useEffect, useState } from 'react';
import "./Quality.css";

function Quality () {
    let [ mobile, setMobile ] = useState( false );

    useEffect( () => {
        window.scrollTo( 0, 0 );
        if ( document.getElementById( "root" ).clientWidth < 600 ) {
            setMobile( true );
        }
    }, [] );

    return (
        <div className='about-container'>
            <div className='products-banner'>
                {!mobile && <img src={require( "../../images/quality/banner.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                {mobile && <img src={require( "../../images/quality/banner-mobile.avif" )} alt="quality-banner" height={"100%"} width={"100%"} />}
                <div className='products-banner-content'>
                    <span>Quality Assurance</span>
                    <span>Get a grip on Quality: Stick to Aero Fasteners for better hold</span>
                </div>
            </div>
            <div className='about-header'>
                We have a well equipped lab. We plan to have our lab NABL (ISO 17025).
            </div>
            <div className='about-content'>
                With our in-house well equipped lab, we have competence to fabricate Precision Machined Components complying with national and international quality standards and manufacturing regulations. Our products are designed for various markets catering to unique demands of our customers.
            </div>
            <div className='about-middle'>
                <img src={require( "../../images/quality/image.avif" )} alt="quality-middle" height={"100%"} width={"100%"} />
                <div className='about-middle-content'>
                    <div>
                        Conforming to various international and national standards or custom built, our products are put through rigorous test based on tensile strength, dimension, technical and other physical properties, making our quality and service unparalleled in the market.
                    </div>
                </div>
            </div>
            <div className='about-middle'>
                <div className='about-middle-content' style={{ padding: "0 1rem 0 0" }}>
                    <div style={{ marginBottom: '1rem' }} className='about-content-header'>Few of the instruments that we already have in our lab:-</div>
                    <ul>
                        <li>Hardness Testers</li>
                        <li>Metallurgical Microscope (Inverted Type)</li>
                        <li>MPI (Magnetic Particle Inspection)</li>
                        <li>Coating Thickness Tester</li>
                        <li>Profile Projector</li>
                        <li>Salt Spray Chamber</li>
                        <li>UTM (100 Ton capacity for precise measurements with complete software for graph and analysis)</li>
                        <li>In House Tool Room</li>
                        <li>All required gauges and instruments</li>
                        <li>Adding more instruments day by day…</li>
                    </ul>
                </div>
                <img src={require( "../../images/quality/image2.avif" )} alt="quality-middle" height={"100%"} width={"100%"} />
            </div>
            <div className='about-content' style={{ gap: "1rem" }}>
                <div className='about-content-header'>Our Strength</div>
                <span>Cold Forging capabilities starting from 1.6 mm</span>
                <ol>
                    <li>Providing reliable quality products</li>
                    <li>On time deliveries</li>
                    <li>Right price</li>
                </ol>
            </div>
        </div>
    )
}

export default Quality
